/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Cards from "react-credit-cards-2";
import "react-credit-cards-2/dist/es/styles-compiled.css";

const PosnetPayment = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [cardData, setCardData] = useState({
    cardHolderName: "",
    ccno: "",
    expDate: "",
    cvc: "",
  });
  const [focus, setFocus] = useState("");

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/posnet/odeme-detay/${orderId}`,
        );
        const result = await response.json();
        if (result.success && result.amount) {
          setAmount(result.amount);
        } else {
          console.error("Ödeme detayları alınamadı:", result.message);
        }
      } catch (error) {
        console.error("Ödeme detayları yüklenirken hata oluştu:", error);
      }
    };

    if (orderId) {
      fetchPaymentDetails();
    }
  }, [orderId]);

  const handleInputChange = (field, value) => {
    let cleanValue = value;

    if (field === "ccno") {
      cleanValue = value.replace(/\D/g, "");
      cleanValue = cleanValue.substring(0, 16);
      const formatted = cleanValue.match(/.{1,4}/g)?.join(" ") || cleanValue;
      setCardData({ ...cardData, [field]: formatted });
      return;
    }

    if (field === "expDate") {
      cleanValue = value.replace(/\D/g, "");
      cleanValue = cleanValue.substring(0, 4);
      if (cleanValue.length >= 2) {
        cleanValue = cleanValue.substring(0, 2) + "/" + cleanValue.substring(2);
      }
      setCardData({ ...cardData, [field]: cleanValue });
      return;
    }

    if (field === "cvc") {
      cleanValue = value.replace(/\D/g, "").substring(0, 3);
    }

    if (field === "cardHolderName") {
      cleanValue = value.toUpperCase().replace(/[^A-ZÇĞİÖŞÜ\s]/g, "");
    }

    setCardData({ ...cardData, [field]: cleanValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const cleanCcno = cardData.ccno.replace(/\s/g, "");

      const cleanExpDate = cardData.expDate.replace(/\//g, "");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/posnet/posnet-odeme`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cardHolderName: cardData.cardHolderName,
            ccno: cleanCcno,
            expDate: cleanExpDate,
            cvc: cardData.cvc,
            amount: amount,
            currencyCode: "TL",
            installment: "00",
            orderId: orderId,
          }),
        },
      );

      const result = await response.json();

      if (result.success && result.redirectData) {
        const form = document.createElement("form");
        form.method = result.redirectData.method;
        form.action = result.redirectData.action;

        Object.keys(result.redirectData.fields).forEach((key) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = result.redirectData.fields[key];
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
      } else {
        alert(
          result.error || "Ödeme işlemi başlatılamadı. Lütfen tekrar deneyin.",
        );
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Ödeme hatası:", error);
      alert("Bağlantı hatası. Lütfen tekrar deneyin.");
      setIsLoading(false);
    }
  };

  const isFormValid = () => {
    const cleanCcno = cardData.ccno.replace(/\s/g, "");
    const cleanExpDate = cardData.expDate.replace(/\//g, "");

    return (
      cardData.cardHolderName.trim().length > 0 &&
      cleanCcno.length >= 15 &&
      cleanCcno.length <= 16 &&
      cleanExpDate.length === 4 &&
      cardData.cvc.length === 3
    );
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          maxWidth: "500px",
          width: "100%",
          background: "white",
          borderRadius: "24px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            padding: "30px 20px",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              color: "white",
              margin: "0 0 8px 0",
              fontSize: "clamp(20px, 5vw, 28px)", // 🔴 RESPONSIVE FONT
              fontWeight: "700",
            }}
          >
            Güvenli Ödeme
          </h2>
          <p
            style={{
              color: "rgba(255,255,255,0.9)",
              margin: 0,
              fontSize: "clamp(12px, 3vw, 14px)", // 🔴 RESPONSIVE FONT
            }}
          >
            🔒 256-bit SSL şifreleme koruması
          </p>
        </div>

        <div
          style={{
            padding: "30px 20px", // 🔴 MOBİL İÇİN DÜŞÜRÜLDÜ
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
              border: "2px solid #10b981",
              borderRadius: "16px",
              padding: "15px",
              marginBottom: "25px",
              textAlign: "center",
              boxShadow: "0 4px 15px rgba(16, 185, 129, 0.1)",
            }}
          >
            <p
              style={{
                margin: "0 0 5px 0",
                color: "#065f46",
                fontSize: "clamp(11px, 2.5vw, 13px)", // 🔴 RESPONSIVE FONT
                fontWeight: "600",
              }}
            >
              Ödenecek Tutar
            </p>
            <p
              style={{
                margin: 0,
                color: "#047857",
                fontSize: "clamp(24px, 6vw, 32px)", // 🔴 RESPONSIVE FONT
                fontWeight: "800",
              }}
            >
              {(parseInt(amount) / 100).toFixed(2)} ₺
            </p>
          </div>

          {/* 🔴 RESPONSIVE CARD WRAPPER */}
          <div
            style={{
              marginBottom: "30px",
              display: "flex",
              justifyContent: "center",
              overflow: "hidden", // Taşmayı önle
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: "290px", // Maksimum genişlik
                transform: "scale(1)", // Scale kaldırıldı
              }}
            >
              <Cards
                number={cardData.ccno}
                name={cardData.cardHolderName}
                expiry={cardData.expDate}
                cvc={cardData.cvc}
                focused={focus}
              />
            </div>
          </div>

          <form onSubmit={handleSubmit} autoComplete="off">
            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "clamp(13px, 3vw, 14px)", // 🔴 RESPONSIVE FONT
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Kart Üzerindeki İsim *
              </label>
              <input
                type="text"
                name="cc-name"
                autoComplete="cc-name"
                value={cardData.cardHolderName}
                onChange={(e) =>
                  handleInputChange("cardHolderName", e.target.value)
                }
                onFocus={() => setFocus("name")}
                required
                placeholder="AD SOYAD"
                style={{
                  width: "100%",
                  height: "52px",
                  padding: "14px 16px",
                  border: "2px solid #e2e8f0",
                  borderRadius: "12px",
                  fontSize: "15px",
                  boxSizing: "border-box",
                  transition: "all 0.3s ease",
                  outline: "none",
                }}
                onFocusCapture={(e) => {
                  e.target.style.borderColor = "#667eea";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(102, 126, 234, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e2e8f0";
                  e.target.style.boxShadow = "none";
                }}
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "clamp(13px, 3vw, 14px)", // 🔴 RESPONSIVE FONT
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Kart Numarası *
              </label>
              <input
                type="text"
                name="cc-number"
                autoComplete="cc-number"
                inputMode="numeric"
                value={cardData.ccno}
                onChange={(e) => handleInputChange("ccno", e.target.value)}
                onFocus={() => setFocus("number")}
                required
                placeholder="1234 5678 9012 3456"
                maxLength="19"
                style={{
                  width: "100%",
                  height: "52px",
                  padding: "14px 16px",
                  border: "2px solid #e2e8f0",
                  borderRadius: "12px",
                  fontSize: "15px",
                  boxSizing: "border-box",
                  transition: "all 0.3s ease",
                  outline: "none",
                }}
                onFocusCapture={(e) => {
                  e.target.style.borderColor = "#667eea";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(102, 126, 234, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e2e8f0";
                  e.target.style.boxShadow = "none";
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "15px",
                marginBottom: "30px",
                alignItems: "flex-end",
              }}
            >
              <div style={{ flex: 1 }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "clamp(13px, 3vw, 14px)", // 🔴 RESPONSIVE FONT
                    fontWeight: "600",
                    color: "#374151",
                    minHeight: "20px",
                  }}
                >
                  Son Kullanma (MM/YY) *
                </label>
                <input
                  type="text"
                  name="cc-exp"
                  autoComplete="cc-exp"
                  inputMode="numeric"
                  value={cardData.expDate}
                  onChange={(e) => handleInputChange("expDate", e.target.value)}
                  onFocus={() => setFocus("expiry")}
                  required
                  placeholder="MM/YY"
                  maxLength="5"
                  style={{
                    width: "100%",
                    height: "52px",
                    padding: "14px 16px",
                    border: "2px solid #e2e8f0",
                    borderRadius: "12px",
                    fontSize: "15px",
                    boxSizing: "border-box",
                    transition: "all 0.3s ease",
                    outline: "none",
                  }}
                  onFocusCapture={(e) => {
                    e.target.style.borderColor = "#667eea";
                    e.target.style.boxShadow =
                      "0 0 0 3px rgba(102, 126, 234, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#e2e8f0";
                    e.target.style.boxShadow = "none";
                  }}
                />
              </div>

              <div style={{ flex: 1 }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "clamp(13px, 3vw, 14px)", // 🔴 RESPONSIVE FONT
                    fontWeight: "600",
                    color: "#374151",
                    minHeight: "20px",
                  }}
                >
                  CVV *
                </label>
                <input
                  type="text"
                  name="cc-csc"
                  autoComplete="cc-csc"
                  inputMode="numeric"
                  value={cardData.cvc}
                  onChange={(e) => handleInputChange("cvc", e.target.value)}
                  onFocus={() => setFocus("cvc")}
                  required
                  placeholder="123"
                  maxLength="3"
                  style={{
                    width: "100%",
                    height: "52px",
                    padding: "14px 16px",
                    border: "2px solid #e2e8f0",
                    borderRadius: "12px",
                    fontSize: "15px",
                    boxSizing: "border-box",
                    transition: "all 0.3s ease",
                    outline: "none",
                  }}
                  onFocusCapture={(e) => {
                    e.target.style.borderColor = "#667eea";
                    e.target.style.boxShadow =
                      "0 0 0 3px rgba(102, 126, 234, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#e2e8f0";
                    e.target.style.boxShadow = "none";
                  }}
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading || !isFormValid()}
              style={{
                width: "100%",
                padding: "16px",
                background:
                  isLoading || !isFormValid()
                    ? "#cbd5e1"
                    : "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                color: "white",
                border: "none",
                borderRadius: "12px",
                fontSize: "clamp(15px, 3.5vw, 17px)", // 🔴 RESPONSIVE FONT
                fontWeight: "700",
                cursor: isLoading || !isFormValid() ? "not-allowed" : "pointer",
                boxShadow:
                  isLoading || !isFormValid()
                    ? "none"
                    : "0 6px 20px rgba(16, 185, 129, 0.4)",
                transition: "all 0.3s ease",
                transform:
                  isLoading || !isFormValid() ? "none" : "translateY(0)",
              }}
              onMouseEnter={(e) => {
                if (!isLoading && isFormValid()) {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 8px 25px rgba(16, 185, 129, 0.5)";
                }
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 6px 20px rgba(16, 185, 129, 0.4)";
              }}
            >
              {isLoading
                ? "🔄 3D Secure'e yönlendiriliyor..."
                : `💳 ${(parseInt(amount) / 100).toFixed(2)}₺ Öde`}
            </button>
          </form>

          <div
            style={{
              marginTop: "25px",
              paddingTop: "20px",
              borderTop: "1px solid #e2e8f0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            {/* <img
              src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg"
              alt="Visa"
              style={{ height: "20px", opacity: 0.7 }}
            /> */}
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg"
              alt="Mastercard"
              style={{ height: "25px", opacity: 0.7 }}
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/2/25/Troy_logo.png"
              alt="TROY"
              style={{ height: "20px", opacity: 0.7, width: "35px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PosnetPayment;
